import { apiSlice } from '../../../app/services/apiSlice';
import { MeetingRoles, NotifyRoles } from '../../ReInterviews/assets/utills';

const ACCOUNT_URL = 'accounts';
const TEMPLATES_URL = 'templates';
const ESIGN_URL = 'e-signee';

export const extendedApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    addNewUser: builder.mutation({
      query: (data) => ({
        url: `${ACCOUNT_URL}`,
        method: 'POST',
        body: {
          ...data,
        },
      }),
    }),
    updateUser: builder.mutation({
      query: (data) => ({
        url: `${ACCOUNT_URL}/${data.id}`,
        method: 'PUT',
        body: {
          ...data,
        },
      }),
    }),
    emailTemplateCreation: builder.mutation({
      query: (data) => ({
        url: `templates`,
        method: 'POST',
        body: {
          ...data,
        },
      }),
    }),
    emailTemplateDraft: builder.mutation({
      query: (data) => ({
        url: `templates`,
        method: 'POST',
        body: {
          ...data,
        },
      }),
    }),
    preSignedProfileUrl: builder.mutation({
      query: (data) => ({
        url: `accounts/preSignedProfileImage`,
        method: 'POST',
        body: {
          ...data,
        },
      }),
    }),
    resendInvite: builder.mutation({
      query: (id) => ({
        url: `${ACCOUNT_URL}/${id}/resend-invite`,
        method: 'GET',
      }),
    }),
    getShortCodes: builder.query({
      query: (params) => ({
        url: `shortcodes`,
        params,
      }),
    }),
    getStandardShortCodes: builder.mutation({
      query: (params) => ({
        url: `shortcodes`,
        method: 'GET',
        params: params,
      }),
    }),
    getEmailAllTemplates: builder.query({
      query: (params) => ({
        url: `templates`,
        params,
      }),
    }),
    getAllJobsTemplatess: builder.query({
      query: (params) => ({
        url: `template/jobs`,
        method: 'GET',
        params,
      }),
    }),
    jobTemplateCreation: builder.mutation({
      query: (data) => ({
        url: `template/jobs`,
        method: 'POST',
        body: {
          ...data,
        },
      }),
    }),
    deletejobTemplate: builder.mutation({
      query: (id) => ({
        url: `template/job/${id}`,
        method: 'DELETE',
      }),
    }),
    // getSingleJobTemplateById: builder.mutation({
    //   query: (id) => ({
    //     url: `${TEMPLATES_URL}/job/${id}`,
    //     method: 'GET',
    //   }),
    // }),
    getSingleEmailTemplateById: builder.mutation({
      query: (id) => ({
        url: `${TEMPLATES_URL}/${id}`,
        method: 'GET',
      }),
    }),
    getEmailTemplateById: builder.query({
      query: (id) => ({
        url: `${TEMPLATES_URL}/${id}`,
        method: 'GET',
      }),
    }),
    deleteTemplate: builder.mutation({
      query: (params) => ({
        url: `${TEMPLATES_URL}/${params}`,
        method: 'DELETE',
      }),
    }),
    updateInfo: builder.mutation({
      query: (data) => ({
        url: `${ACCOUNT_URL}/${data.id}`,
        method: 'PUT',
        body: {
          ...data.obj,
        },
      }),
    }),

    getProfileInformation: builder.query({
      query: () => ({
        url: `accounts/by-token`,
      }),
    }),
    getCompanyProfile: builder.query({
      query: () => ({
        url: `company`,
      }),
    }),
    getAllEsignee: builder.query({
      query: (params) => ({
        url: `${ESIGN_URL}`,
        params,
      }),
    }),
    getAllSignee: builder.mutation({
      query: (params) => ({
        url: `${ESIGN_URL}`,
        params,
      }),
      transformResponse: (responseData) => {
        responseData.options = responseData?.esignees?.map((op) => ({
          title: `${op?.name}`,
          value: op.id,
          designation: op?.designation,
          email: op?.email,
        }));
        return responseData || {};
      },
    }),
    addEsignee: builder.mutation({
      query: (data) => ({
        url: `${ESIGN_URL}`,
        method: 'POST',
        body: {
          ...data,
        },
      }),
    }),
    getSingleEsigneeById: builder.mutation({
      query: (id) => ({
        url: `${ESIGN_URL}/${id}`,
        method: 'GET',
      }),
    }),
    deleteEsignee: builder.mutation({
      query: (id) => ({
        url: `${ESIGN_URL}/${id}`,
        method: 'DELETE',
      }),
    }),
    updateEsignee: builder.mutation({
      query: (data) => ({
        url: `${ESIGN_URL}/${data.id}`,
        method: 'PUT',
        body: {
          ...data,
        },
      }),
    }),
    getAllEmployees: builder.query({
      query: (params) => ({
        url: `${ACCOUNT_URL}`,
        params,
      }),
    }),
    getAllEmployeesList: builder.mutation({
      query: (data) => ({
        url: `${ACCOUNT_URL}`,
        method: 'GET',
        params: data,
      }),
      transformResponse: (responseData) => {
        responseData.options = responseData?.accounts?.map((cat) => ({
          ...cat,
          title: `${cat?.firstName} ${cat?.lastName}`,
          value: cat.id,
          name: `${cat?.firstName} ${cat?.lastName}`,
        }));
        return responseData || {};
      },
    }),
    getAccountDetails: builder.mutation({
      query: (accountId) => ({
        url: `${ACCOUNT_URL}/details`,
        method: 'GET',
        params: { accountId },
      }),
    }),
    getEntityId: builder.mutation({
      query: (data) => ({
        url: `job/entity-details`,
        method: 'GET',
        params: data,
      }),
    }),
     getShortCodeValidation: builder.mutation({
      query: (data) => ({
        url: `shortcodes/check`,
        method: 'POST',
        body: {
          ...data,
        },
      }),
    }),

    addCompanyUser: builder.mutation({
      query: (data) => ({
        url: `company/${data.companyId}/add-users`,
        method: 'POST',
        body: {
          ...data,
        },
      }),
    }),
    deleteUser: builder.mutation({
      query: (params) => ({
        url: `${ACCOUNT_URL}`,
        method: 'DELETE',
        params,
      }),
    }),

    getAllCompanyUsers: builder.mutation({
      query: (params) => ({
        url: `${ACCOUNT_URL}`,
        params,
      }),
      transformResponse: (responseData) => {
        responseData.options = responseData?.accounts?.map((account) => ({
          ...account,
          value: account?.id,
          title: `${account?.firstName || ''} ${account?.lastName || ''}`,
        }));
        responseData.total = responseData?.totalCount;
        responseData.page = responseData.currentPage;
        return responseData || {};
      },
    }),
    updateTemplate: builder.mutation({
      query: (data) => ({
        url: `${TEMPLATES_URL}/${data.id}`,
        method: 'PUT',
        body: {
          ...data,
        },
      }),
    }),
    removeBulkUsers: builder.mutation({
      query: (data) => ({
        url: `${ACCOUNT_URL}/bulk-delete`,
        method: 'PUT',
        body: {
          ...data,
        },
      }),
    }),
    preEMailTemplateUrl: builder.mutation({
      query: (data) => ({
        url: `${TEMPLATES_URL}/preSignedTemplateAttachment`,
        method: 'POST',
        body: {
          ...data,
        },
      }),
    }),
    preSignedHiringUpload: builder.mutation({
      query: (data) => ({
        url: `hiring-plans/pre-signed-doc`,
        method: 'POST',
        body: {
          ...data,
        },
      }),
    }),
    updateCompanyProfile: builder.mutation({
      query: (data) => ({
        url: `company`,
        method: 'PUT',
        body: {
          ...data,
        },
      }),
    }),
    updateProfile: builder.mutation({
      query: ({ profileData }) => ({
        url: ACCOUNT_URL,
        method: 'PUT',
        body: profileData,
      }),
    }),
    updateCompanyProfileImage: builder.mutation({
      query: (data) => ({
        url: `company`,
        method: 'PUT',
        body: {
          ...data.compLOGOSignedUrl,
        },
      }),
    }),

    getAllRoles: builder.mutation({
      query: (params) => ({
        url: `roles`,
        params,
      }),
      transformResponse: (responseData) => {
        responseData.options = responseData?.roles
          ?.sort((a, b) => (a.name || '').localeCompare(b.name || ''))
          ?.map((role) => ({
            ...role,
            value: role.id,
            label: role.name,
            title: role.name,
          }));
        return responseData || {};
      },
    }),
    getCompanyRoles: builder.mutation({
      query: (params) => ({
        url: `company-roles`,
        params,
      }),
      transformResponse: (responseData) => {
        responseData.options = responseData?.data
          ?.sort((a, b) => a.name.localeCompare(b.name))
          ?.map((role) => ({
            ...role,
            value: role.id,
            label: role.name,
            title: role.name,
          }));
        return responseData || {};
      },
    }),
    getInterviewRoles: builder.mutation({
      query: (params) => ({
        url: `roles`,
      }),
      transformResponse: (responseData) => {
        responseData.options = MeetingRoles;
        return responseData || {};
      },
    }),
    getNotifyRoles: builder.mutation({
      query: (params) => ({
        url: `roles`,
      }),
      transformResponse: (responseData) => {
        responseData.options = NotifyRoles;
        return responseData || {};
      },
    }),
    inviteNewUser: builder.mutation({
      query: (data) => ({
        url: `${ACCOUNT_URL}`,
        method: 'POST',
        body: {
          ...data,
        },
      }),
    }),
    getAccountCounts: builder.query({
      query: () => `company/accounts-count`,
    }),
  }),
});

export const {
  useGetShortCodeValidationMutation,
  useGetAllSigneeMutation,
  useGetAllEsigneeQuery,
  useGetEntityIdMutation,
  useGetSingleEsigneeByIdMutation,
  useAddEsigneeMutation,
  useDeleteEsigneeMutation,
  useUpdateEsigneeMutation,
  useInviteNewUserMutation,
  useEmailTemplateCreationMutation,
  useEmailTemplateDraftMutation,
  useAddNewUserMutation,
  useUpdateUserMutation,
  useGetAllEmployeesQuery,
  useGetProfileInformationQuery,
  useGetCompanyProfileQuery,
  usePreSignedHiringUploadMutation,
  useUpdateInfoMutation,
  useGetAllEmployeesListMutation,
  useGetAccountDetailsMutation,
  useAddCompanyUserMutation,
  useResendInviteMutation,
  useDeleteUserMutation,
  usePreSignedProfileUrlMutation,
  useUpdateProfileMutation,
  useUpdateCompanyProfileMutation,
  useUpdateCompanyProfileImageMutation,
  useDeleteTemplateMutation,
  useRemoveBulkUsersMutation,
  useGetEmailAllTemplatesQuery,
  useGetAllJobsTemplatessQuery,
  useGetShortCodesQuery,
  usePreEMailTemplateUrlMutation,
  useGetSingleEmailTemplateByIdMutation,
  useUpdateTemplateMutation,
  useGetAllRolesMutation,
  useGetCompanyRolesMutation,
  useGetInterviewRolesMutation,
  useGetNotifyRolesMutation,
  useGetAllCompanyUsersMutation,
  useGetAccountCountsQuery,
  useJobTemplateCreationMutation,
  useDeletejobTemplateMutation,
  useGetEmailTemplateByIdQuery,
  useGetStandardShortCodesMutation,
  // useGetSingleJobTemplateByIdMutation
} = extendedApiSlice;
